<button [class]="cssClassSuffix ? 'offers-table-cell offers-table-cell--' + cssClassSuffix : 'offers-table-cell'"
        (click)="selectOffer()"
        [ngClass]="{
          'offers-table-cell--selectable': selectable,
          'offers-table-cell--selected': selected,
          'offers-table-cell--recommended': recommendationActive
        }">
  <div *ngIf="recommendationActive"
       class="offers-table-cell__recommendation">
    {{ recommendationConfig.title | translate }}
  </div>
  <div class="offers-table-cell__content">
    <div class="offers-table-cell__content__left">
      <div *ngIf="offer"
           class="offers-table-cell__content__price">
        <app-offer-price [offer]="offer">
        </app-offer-price>
      </div>
      <button class="offers-table-cell__content__offer-details btn btn--clear"
              (click)="showOfferDetails()">
        {{'OFFER_SECTION.details' | translate}}
        <span class="material-icons">arrow_right</span>
      </button>
    </div>

    <div class="offers-table-cell__content__right">
      <div class="offers-table-cell__content__buy-online">
        <button class="btn btn--secondary btn--small-padding"
                (click)="buy()">
          {{'OFFER_SECTION.SHARED.buyOnline' | translate}}
        </button>
      </div>
    </div>

    <div *ngIf="!offer"
         class="offers-table-cell__content__no-offer">
      <span class="material-icons">close</span>
    </div>
  </div>
</button>
